<mat-dialog-content>
    <p>Voulez-vous vraiment supprimer cet élément?</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onClose(false)">Non</button>
    <button class="yesBtn" mat-stroked-button color="warn" (click)="onClose(true)">Oui</button>
</mat-dialog-actions>
